import { getRegisteredDomain, urlToDomain } from "../utils/domains";

/**
 * The base event from which all RecordableEvents must be derived.
 */
export interface DataGoesWhereEventBase<
	CATEGORY extends string,
	SUBTYPE extends string,
	RAW
> {
	/**
	 * A category of event
	 */
	readonly category: CATEGORY;
	/**
	 * An event name within that category.
	 */
	readonly eventName: SUBTYPE;
	/**
	 * This represents a raw event that has been observed and is not modified in any way.
	 * Any augmentation MUST be placed elsewhere, so that we separate information collected
	 * from the browser from information that this extension derives from it.
	 */
	readonly raw: Readonly<RAW>;
}

export interface UrlField {
	/**
	 * A URL
	 */
	readonly url: string;
}

export interface ObservedTabFields extends UrlField {
	/**
	 * The ID of the tab from which this event originated.
	 */
	readonly tabId: number;
	/**
	 * The URL of the tab from which this event originated.
	 */
	readonly url: string;
}

export interface DomainMetadataDerivedFromUrl {
	/**
	 * The domain derived from the URL
	 */
	readonly domain?: string;
	/**
	 * The registered domain derived from domain. A registered domain is the
	 * domain underneath the registrar (`example.com` derived from `api.example.com`)
	 * that best approximates an organization (though many organizations have multiple domains,
	 * and many organizations share cloud services).
	 */
	readonly registeredDomain?: string;
}

export const addDomainMetadataToObjectWithUrlField= <T extends UrlField>(
	obj: T
): T & DomainMetadataDerivedFromUrl => {
	const domain = urlToDomain(obj.url);
	const registeredDomain = getRegisteredDomain(domain);
	return { ...obj, domain, registeredDomain };
}

// /**
//  * The base for all events that take place within in a tab,
//  * which the event should be associated with.
//  */
// export interface DataGoesWhereEventBase <
// 	CATEGORY extends string,
// 	SUBTYPE extends string,
// 	DATA,
// > extends DataGoesWhereEventBase<CATEGORY, SUBTYPE, DATA> {
// 	readonly tab: ObservedTabFields;
// }
